import React, { useState } from "react";
import Categories from "./Categories";
import items from "./data";

const Menu = () => {
  const [category, setCategory] = useState("All");

  const filteredItems =
    category === "All"
      ? items
      : items.filter((item) => item.category === category);

  console.log(category);

  return (
    <main>
      <section className="menu section">
        <div className="title">
          <h2>Our Menu</h2>
          <div className="underline"></div>
        </div>

        <Categories setCategory={setCategory} />

        <div className="section-center">
          {filteredItems.map((menu) => {
            const { id, title, Category, price, img, desc } = menu;
            return (
              <div key={id} className="menu-item">
                <img src={img} alt="" className="photo" />
                <div className="item-info">
                  <header>
                    <h4>{title}</h4>
                    <h4 className="price">{price}</h4>
                  </header>
                  <p className="item-text">{desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default Menu;
